import MorningAcademyPage from "./MorningAcademyPage";

export default function MorningAcademyNachshon() {
  return (
    <MorningAcademyPage
      testIdPrefix="morning-nachshon"
      locationName="ישיבת נחשון"
      titleLine1="אקדמיית הבוקר של"
      titleLine2Red="ישיבת נחשון"
      days="ראשון וחמישי"
      hours="07:00 – 08:00"
      audience={[
        "תלמידי בית הספר נחשון",
        "תלמידי בית הספר הרטוב",
        "שחקני הפועל מטה יהודה ממחלקת הנוער",
      ]}
      whatsappGroupUrl="https://chat.whatsapp.com/LE5XYdPxxCf9j14ypv5ffu"
    />
  );
}
